<template>
  <v-treeview
    v-model="fileInfo.tree"
    :open="fileInfo.initiallyOpen"
    :items="fileInfo.items"
    activatable
    item-key="name"
    open-on-click
    dense>
    <template v-slot:prepend="{ item, open }">
      <v-icon v-if="!item.file">
        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
      </v-icon>
      <v-icon v-else>
        {{ fileInfo.files[item.file] }}
      </v-icon>
      <v-icon v-if="item.new">mdi-check</v-icon>
    </template>
  </v-treeview>
</template>

<script>
  export default {
    props: {
      fileInfo: Object
    },
    data: () => ({
    }),
  }
</script>